import { select, takeLatest, all, put, call } from 'redux-saga/effects'
import { flatMap } from 'lodash'

import {
  GET_ATTRACT_LOOP_IMAGES,
  GET_CAROUSEL_IMAGES,
  getCarouselImagesFailure,
  getCarouselImagesSuccess,
  setCarouselImagesLoading,
} from '../../actions/carouselImages'
import { checkImagesExist, getImagePath } from '../../kiosk/utils/carousel'
import { getSelectedMenusIds } from '../../selectors/config'
import { getImagesForSelectedMenus } from '../../selectors/menus'
import { ATTRACT_LOOP_CACHE_CATEGORY, cacheImage, clearImageCache } from '../../VNImageCache/utils'
import { getKioskOfflineEnabled } from '../../kiosk/utils/config'
import { isFeatureOn } from '../../VNConfigurations/Selectors'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../../VNConfigurations/Enums'

// legacy saga for manually set carousel images
export function* getCarouselImages() {
  try {
    const imageVersion = Date.now()
    const selectedMenuIds = yield select(getSelectedMenusIds)
    const imagesAmount = 5

    yield put(setCarouselImagesLoading())

    const imageNumbers = [...Array(imagesAmount).keys()].map((x) => x + 1)
    const imagePaths = yield all(
      flatMap(selectedMenuIds, (menuUuid) => {
        return imageNumbers.map((imageNumber) => getImagePath(menuUuid, imageNumber, imageVersion))
      }),
    )
    const existingImages = imagePaths.filter((path) => !!path)

    yield put(getCarouselImagesSuccess(existingImages))
  } catch (error) {
    console.error(error)
    yield put(getCarouselImagesFailure())
  }
}

export function* watchGetCarouselImages() {
  yield takeLatest(GET_CAROUSEL_IMAGES, getCarouselImages)
}

/**
 * Fetch custom attract loop images for the selected menus and validate their existence.
 * Dispatches an action to update the state with the validated image URLs.
 */
export function* getCustomAttractLoopImagesSaga() {
  const menuImages = yield select(getImagesForSelectedMenus)
  const attractLoopUrls = menuImages.map((image) => image.list).filter((url) => !!url)
  yield put(setCarouselImagesLoading())
  try {
    const validatedImages = yield call(checkImagesExist, attractLoopUrls)
    yield put(getCarouselImagesSuccess(validatedImages))

    const kioskOfflineEnabled = yield call(getKioskOfflineEnabled, { fromAttractLoop: true })

    const disableCacheImages = yield select((state) => isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.DISABLE_CACHE_IMAGES))

    //Always delete cached attract loop images
    yield call(clearImageCache, ATTRACT_LOOP_CACHE_CATEGORY)

    //Just in case we run into some issue with the image caching, we don't want to block the kiosk from working
    if (!kioskOfflineEnabled || disableCacheImages) {
      return
    }

    for (let url of validatedImages) {
      yield call(cacheImage, ATTRACT_LOOP_CACHE_CATEGORY, url)
    }
  } catch (error) {
    console.error(error)
    yield put(getCarouselImagesFailure())
  }
}

export function* watchGetAttractLoopImages() {
  yield takeLatest(GET_ATTRACT_LOOP_IMAGES, getCustomAttractLoopImagesSaga)
}
